/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_About_SourcesInputs */

const en_cmp_about_sources = /** @type {(inputs: Cmp_About_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sources`)
};

const id_cmp_about_sources = /** @type {(inputs: Cmp_About_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumber`)
};

/**
* | output |
* | --- |
* | "Sources" |
*
* @param {Cmp_About_SourcesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_about_sources = /** @type {((inputs?: Cmp_About_SourcesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_About_SourcesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_about_sources(inputs)
	return en_cmp_about_sources(inputs)
});